import { render, staticRenderFns } from "./loyalty-header.vue?vue&type=template&id=4fa8de13&scoped=true&"
import script from "./loyalty-header.ts?vue&type=script&lang=ts&"
export * from "./loyalty-header.ts?vue&type=script&lang=ts&"
import style0 from "./loyalty-header.scss?vue&type=style&index=0&id=4fa8de13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8de13",
  null
  
)

component.options.__file = "loyalty-header.vue"
export default component.exports